import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import Avatar from '@material-ui/core/Avatar';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import Grid from '@material-ui/core/Grid';


const useStyles = makeStyles(theme => ({
  card: {
    maxWidth: "100%",
  },
  image: {
    width: 'auto',
    maxWidth: '180px',
    minWidth: '96px',
    height: 'auto',
    maxHeight: '140px',
    objectFit: 'contain',
    display: 'block',
    margin: '0 auto',
  },
  content_text: {
    padding: theme.spacing(1, 0, 1, 2),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(2, 1, 0, 1),
    },
  },
  content_img: {
    textAlign: 'center',
    flexShrink: 0,
    paddingRight: theme.spacing(1),
  },

  avatar: {
    backgroundColor: red[500],
  },
}));

export default function PracticasTipos({ data, image }) {
  let { nombre, descripcion, opciones } = data;
  const classes = useStyles();

  return (
    <Card className={classes.card} style={{ cursor: 'pointer' }} elevation={1}>
      <CardHeader
        avatar={<Avatar aria-label="recipe" className={classes.avatar}> {nombre.charAt(0)} </Avatar>}
        title={`${nombre}`}
        subheader={opciones}
      />
      <CardContent >
        <Grid container direction={'row'} justifyContent={'flex-start'} alignItems={'flex-start'} spacing={2}>
          <Grid item xs={12} sm={3} md={3} className={classes.content_img}>
            <img src={image} className={classes.image} alt='Imagen Tipo' />
          </Grid>
          <Grid item xs={12} sm={9} md={9} className={classes.content_text}>
            <Typography variant="body2" color="textSecondary" component="p" align='justify' style={{ wordBreak: 'break-word' }}>
              {descripcion}
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
